export const getVersionLabel = (state) => state.maps.versionLabel;
